import { InteriorNPC } from "GameObjects/GameInterior/InteriorNPC";

import type { ILevelState } from "Interfaces/ILevelState";

export class InteriorNPCReturnItems extends InteriorNPC {

    protected right: number = 100; // eyeballed
    protected bottom: number = 0;

    public init(pSize: PIXI.Point, pData: ILevelState) {
        super.init(pSize, pData);
        return this;
    }

    public animateIn() {
        super.animateIn();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
    }
}
